 var tabsHeading = document.querySelectorAll('.tabs--heading button');
    var tabsDescription = document.querySelectorAll('.tabs--description');

    tabsHeading.forEach(function (button) {
        button.addEventListener('click', function () {
           var getAttribute = button.getAttribute('data-head');
             tabsHeading.forEach(function (btn) {
                btn.classList.remove('active');
            });
             button.classList.add('active');
             tabsDescription.forEach(function (desc) {
                desc.classList.remove('active');
            });
             var matchingDescription = document.querySelector(`.tabs--description[data-head="${getAttribute}"]`);
            if (matchingDescription) {
                matchingDescription.classList.add('active');
            } else {
               
            }
        });
    });

